import { defaultPagination } from "@/services/pagination";
import { listSnapshotDetails, listSnapshots } from "@/services/api/app/office/entraId/file";
import backups from "@/store/app/office/recovery/entraId/backups"
import compares from "@/store/app/office/recovery/entraId/compares"
import exports from "@/store/app/office/recovery/entraId/exports"
import restores from "@/store/app/office/recovery/entraId/restores";
import {listInitialBackupStats} from "@/services/api/app/common/initialBackup";

const defaultState = () => ({
  files: [],
  pagination: {
    ...defaultPagination(),
    sortBy: 'displayName',
    sortDescending: false
  },
  initialBackupStatus: {},
  search: null,
  searchTerm: null,
})

export default {
  namespaced: true,

  actions: {
    listSnapshotDetails({commit, state}, data) {
      return listSnapshotDetails({
        ...data,
        pagination: state.pagination,
        searchTerm: state.searchTerm
      })
        .then(({result, pagination}) => {
          commit('setFiles', result)
          commit('setPagination', pagination)
        })
    },
    listSnapshots({commit}, {date, dateTo}) {
      return listSnapshots({date, dateTo});
    },
    listInitialBackupStats({commit}, payload) {
      return listInitialBackupStats({
        provider: payload.provider, // 1
        module: payload.module,     // 14
        dataType: payload.dataType, // e.g. 15 (selectedObjectType)
        id: payload.id
      })
        .then((result) => {
          commit('setInitialBackupStatus', result)
          return result;
        })
    },
  },

  mutations: {
    setFiles(state, files) {
      state.files = files;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    setSearch(state, search) {
      state.search = search
    },
    setSearchTerm(state, searchTerm) {
      state.searchTerm = searchTerm;
    },
    setInitialBackupStatus(state, initialBackupStatus) {
      state.initialBackupStatus = initialBackupStatus
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
  },

  modules: {
    backups,
    compares,
    exports,
    restores
  },

  state: defaultState()
}
